import type { PermissionToggles } from '../settings/admin.slice';
import { wrapRequest } from './base';

export const getUserPermissions = async (): Promise<PermissionToggles | null> =>
  wrapRequest('get', 'geonius', '/user_permissions');
